import { MLProductCodeUtil } from 'ml-portals-util-js'
import _ from 'lodash';

function Reinstatement(data) {
    if (data) {
        _.extend(this, data);
    }
}

Reinstatement.prototype.isHomeOwners = function () {
    return MLProductCodeUtil.isHomeOwners(this.product.publicID);
};

Reinstatement.prototype.isPersonalAuto = function () {
    return MLProductCodeUtil.isPersonalAuto(this.product.publicID);
};

Reinstatement.prototype.isPersonalUmbrella = function () {
    return MLProductCodeUtil.isPersonalUmbrella(this.product.publicID);
};

export default Reinstatement;